import { Route, Redirect } from "react-router-dom";
import { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";
import React from "react";

import { LoginStatusProvider } from "./LoginStatusContext";
import logo from "../../assets/utils/images/animetion_logo.gif";
import { SettingOrgTabProvider } from "./SettingOrgTabContext";

const Dashboards = lazy(() => import("../../Pages"));
const UserLogin = lazy(() => import("../../UserLogin"));

const AppMain = () => {
  return (
    <Fragment>
      <LoginStatusProvider>
        <SettingOrgTabProvider>
          <Suspense
            fallback={
              <div className="loader-container">
                <div className="loader-container-inner">
                  <div className="text-center">
                    <Loader type="ball-grid-cy" />
                  </div>
                  <h6 className="mt-3">
                    <img style={{ width: "80px" }} src={logo}></img>
                  </h6>
                </div>
              </div>
            }
          >
            {/* コンポーネント dashboardへ */}
            <Route path="/pages" />
            <Route path="/pages" component={UserLogin} />
            <Route path="/dashboards" component={Dashboards} />
          </Suspense>

          <Route
            exact
            path="/"
            render={() => <Redirect to="/dashboards/journy" />}
          />
        </SettingOrgTabProvider>
      </LoginStatusProvider>
    </Fragment>
  );
};

export default AppMain;
